import { render } from "./BaseHeader.vue?vue&type=template&id=d066c096&scoped=true&ts=true"
import script from "./BaseHeader.vue?vue&type=script&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=d066c096&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d066c096"]])

export default __exports__